import { ClientBase } from "./base.js";
import { RolesClient } from "./roles.js";
/** Inspection draft workflow (I1): with_tech -> review -> sent, plus void/restore/reopen and photos. */
export class InspectionDraftsClient extends RolesClient {
    inspBase(slug, id) {
        const base = `${this.siteBase(slug)}/inspections`;
        return id === undefined ? base : `${base}/${encodeURIComponent(id)}`;
    }
    /** Workflow list: drafts by stage / assignee / order (`mine` = assigned to the caller). */
    async listInspectionWorkflow(slug, params = {}) {
        const res = await this.request("GET", `${this.inspBase(slug)}${ClientBase.query({
            stage: params.stage,
            assignedUserId: params.assignedUserId,
            orderId: params.orderId,
            mine: params.mine ? "true" : undefined,
            includeVoided: params.includeVoided ? "true" : undefined,
        })}`, undefined, true);
        return res.reports;
    }
    async createInspectionDraft(slug, input) {
        return this.request("POST", `${this.inspBase(slug)}/drafts`, input, true);
    }
    /** One-tap save; answers are merged. 409 `stale` when `updatedAt` is out of date. */
    async patchInspection(slug, id, input) {
        return this.request("PATCH", this.inspBase(slug, id), input, true);
    }
    /** Technician hands the draft to review. */
    async submitInspectionDraft(slug, id, updatedAt) {
        return this.request("POST", `${this.inspBase(slug, id)}/submit`, { updatedAt }, true);
    }
    /** Supervisor sends the draft back to the technician. */
    async returnInspection(slug, id, reason) {
        return this.request("POST", `${this.inspBase(slug, id)}/return`, { reason }, true);
    }
    async sendInspection(slug, id, input = {}) {
        return this.request("POST", `${this.inspBase(slug, id)}/send`, input, true);
    }
    /** Answers 201 with the new draft revision. */
    async reopenInspection(slug, id) {
        return this.request("POST", `${this.inspBase(slug, id)}/reopen`, undefined, true);
    }
    async voidInspection(slug, id, reason) {
        return this.request("POST", `${this.inspBase(slug, id)}/void`, { reason }, true);
    }
    async restoreInspection(slug, id) {
        return this.request("POST", `${this.inspBase(slug, id)}/restore`, undefined, true);
    }
    /** Links an existing confirmed private upload to the report; resolves with all photo keys. */
    async addInspectionPhoto(slug, id, input) {
        const res = await this.request("POST", `${this.inspBase(slug, id)}/photos`, input, true);
        return res.photoKeys;
    }
    /** 204. 409 unless the report is still with the technician. */
    async removeInspectionPhoto(slug, id, key) {
        await this.request("DELETE", `${this.inspBase(slug, id)}/photos${ClientBase.query({ key })}`, undefined, true);
    }
}
//# sourceMappingURL=inspectionDrafts.js.map